<template>
  <AttrSelect
    label="温度单位"
    :value="shape.attrs.temperatureUnitType ?? 'celsius'"
    :options="options"
    :disabled="!!disabled"
    @change="onChange"
  />
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { supportFahrenheit } from '@/utils/ast/utils/image-array.utils';
import { PropType, computed } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const watchfaceStore = useWatchfaceStore();

const options = computed(() => {
  if (
    supportFahrenheit(
      watchfaceStore.deviceType,
      props.shape.sourceItem?.key ?? ''
    )
  ) {
    return [
      { label: '跟随固件系统', value: 'system' },
      { label: '摄氏度', value: 'celsius' },
      { label: '华氏度', value: 'fahrenheit' }
    ];
  } else {
    return [{ label: '摄氏度', value: 'celsius' }];
  }
});

const onChange = (val: Shape['attrs']['temperatureUnitType']) => {
  props.shape.setAttrs({ temperatureUnitType: val });
};
</script>
